import { Container } from '@mui/material';
import { ChallengeReport } from 'components/templates';
import React from 'react';
import { useParams } from 'react-router-dom';

export const ChallengeReportView = () => {
  const { challengeId: id } = useParams();
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <ChallengeReport id={id !== undefined ? Number(id) : 0} />
    </Container>
  );
};
